import angular from 'angular';

import Model from './model';
import Trees from './trees';
import FactQuery from './fact-query';
import FactList from './fact-list';

import AnalyticsServ from '../services/analytics';

function CaseFactory(Model, Trees, FactQuery, FactList, AnalyticsServ, $window) {
  return class CaseModel extends Model {
    constructor(data = {}) {
      super(data);
      this.window = $window;
      this.analyticsServ = AnalyticsServ;
      this.revisionInterceptor = {
        response: function (response) {
          var revNo = parseInt(response.headers("X-CASE-REVISION"));
          if (revNo) {
            // Show the Updates Available status indicator
            // only when the local case has fallen behind the servers version
            // If the user incurs the case revision (by a PUT)
            // do not display the status indicator

            if (response.config.method !== 'GET') {
              this.data.revisionNumber++;
            }
            if (revNo > this.data.revisionNumber) {
              this.data.hasUpdates = true;
            }
          }
          return response.resource;
        }
      };
      this.setApi("/case/:caseId", {}, {
        ping: {
          method: 'GET',
          url: '/case/:caseId/ping'
        },
        create: {
          url: '/case',
          method: 'POST',
          success: [
            data => this.success(data),
            data => AnalyticsServ.added('Case')
          ]
        },
        copy: {
          method: 'POST',
          url: '/case/:copyCaseId/copy',
          success: [
            data => this.success(data),
            data => AnalyticsServ.analytics.track('Case Copied')
          ]
        },
        get: {
          method: 'GET',
          params: {
            caseId: '@id'
          },
          interceptor: this.revisionInterceptor,
          success: [data => this.setCase(data)]
        },
        getReport: {
          method: 'GET',
          url: '/case/:caseId/report',
          params: {
            caseId: '@id'
          },
          success: [data => {}]
        },
        update: {
          method: 'PUT',
          params: {
            caseId: '@id'
          },
          success: [
            data => this.setCase(data),
            data => AnalyticsServ[
              data.status === 'archived' ? 'removed' : 'updated'
            ]('Case')
          ]
        }
      });
    }
    setCase(data) {
      if (data) {
        // Set 'side loaded' data if available
        if (data.hasOwnProperty('valueTrees')) {
          Object.keys(data.valueTrees).forEach(key => {
            Trees[key].setData(data.valueTrees[key]);
            Trees[key].setExcludedByQuery(data.query.filterPipeline
              .filter(f => f.attribute === key)
              .shift()
            );
            Trees[key].setCollapsedByQuery(data.query.filterPipeline
              .filter(f => f.attribute === key)
              .shift()
            );
          })
        }
        if (data.hasOwnProperty('factResult')) {
          FactList.setData(data.factResult);
        }
        if (data.hasOwnProperty('query')) {
          FactQuery.setData(data.query);
        }
        this.setData(data);

      } else {
        FactQuery.setData({});
        Object.keys(Trees).forEach(key => {
          Trees[key].setData([])
        });
        FactList.setData({});
        this.setData({})
      }
    }
    getReport() {
      this.window.location.href = `/case/${this.data.id}/report`;
      this.analyticsServ.analytics.track('Case Report Generated');
    }
    getOutline(attr, queryId) {
      let params = {
        attr: attr,
        queryId: queryId
      };
      let paramStr = Object.keys(params)
        .filter((key) => params[key])
        .map((key, index) => (index ? '&' : '?') + `${key}=${params[key]}`)
        .join('');
      this.window.location.href =
        `/case/${this.data.id}/outline${paramStr}`;
      this.analyticsServ.analytics.track('Case Outline Generated');
    }
  }
}
CaseFactory.$inject = ['Model', 'Trees', 'FactQuery', 'FactList',
  'AnalyticsServ', '$window'
];

export default angular.module('models.case', [Model, Trees, FactQuery, FactList,
    AnalyticsServ
  ])
  .factory('Case', CaseFactory)
  .service('CurrentCase', ['Case', Case => new Case()])
  .name;



// WEBPACK FOOTER //
// ./project/models/case.js